import { render } from "./Epilogue.vue?vue&type=template&id=5e8c59d4&scoped=true"
import script from "./Epilogue.vue?vue&type=script&lang=js"
export * from "./Epilogue.vue?vue&type=script&lang=js"

import "./Epilogue.vue?vue&type=style&index=0&id=5e8c59d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8c59d4"]])

export default __exports__